import './Feedback.css';

/**
 * Animated loading state.
 *
 * @param {string}  message  Text under the spinner. Written WITHOUT a trailing
 *                           "..." -- the animated dots are supplied here.
 * @param {string}  variant  'page' fills the viewport slot for a route that has
 *                           nothing to show yet; 'inline' sits inside an
 *                           existing layout, replacing just the part still
 *                           loading.
 */
function Loading({ message = '', variant = 'page', className = '' }) {
    return (
        <div
            className={`mc-loading mc-loading--${variant}${className ? ` ${className}` : ''}`}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className="mc-loading-visual" aria-hidden="true">
                <span className="mc-loading-ring" />
                <span className="mc-loading-ring mc-loading-ring--inner" />
                <span className="mc-loading-core" />
            </div>
            {!!message && (
                <p className="mc-loading-message">
                    {message}
                    {/* Decorative: the message alone is what screen readers announce,
                        and cycling dots would otherwise re-trigger the live region. */}
                    <span className="mc-loading-dots" aria-hidden="true" />
                </p>
            )}
        </div>
    );
}

export default Loading;
